import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const ErrorMessage = ({ message }) => {
  return (
    <Box textAlign="center" color="red.600" mt={8}>
      <Text>Error: {message}</Text>
    </Box>
  );
};

export default ErrorMessage;
